export const calculatorValues = [
  {
    category: "Monthly Income",
    label: "Alimony",
    value: "Alimony",
    type: "income"
  },
  {
    category: "Monthly Income",
    label: "Child Support",
    value: "Alimony",
    type: "income"
  },
  {
    category: "Monthly Income",
    label: "Rent / Other Income",
    value: "Rent / Other Income",
    type: "income"
  },
  {
    category: "Monthly Income",
    label: "Salary / Wages",
    value: "Rent / Other Income",
    type: "income"
  },
  {
    category: "Monthly Income",
    label: "Self-Employment Income",
    value: "Self-Employment Income",
    type: "income"
  },
  {
    category: "Monthly Income",
    label: "Retirement Income",
    value: "Self-Employment Income",
    type: "income"
  },
  {
    category: "Monthly Income",
    label: "Social Security",
    value: "Social Security",
    type: "income"
  },
  {
    category: "Liquid Assets",
    label: "Checking Account",
    value: "Checking Account",
    type: "income"
  },
  {
    category: "Liquid Assets",
    label: "Saving",
    value: "Saving",
    type: "income"
  },
  {
    category: "Liquid Assets",
    label: "Account",
    value: "Account",
    type: "income"
  },
  {
    category: "Liquid Assets",
    label: "Cash",
    value: "Cash",
    type: "income"
  },
  {
    category: "Other Assets",
    label: "Property",
    value: "Property",
    type: "income"
  },
  {
    category: "Other Assets",
    label: "Stocks,Bonds,401k",
    value: "Stocks,Bonds,401k",
    type: "income"
  },
  {
    category: "Other Assets",
    label: "Vehicles",
    value: "Vehicles",
    type: "income"
  },
  {
    category: "Other Assets",
    label: "Other",
    value: "Other",
    type: "income"
  },

  {
    category: "Living Essentials",
    label: "Food",
    value: "Food",
    type: "expenses"
  },
  {
    category: "Living Essentials",
    label: "Cable TV",
    value: "Cable TV",
    type: "expenses"
  },
  {
    category: "Living Essentials",
    label: "Household Items",
    value: "Household Items",
    type: "expenses"
  },
  {
    category: "Living Essentials",
    label: "Mortgage / Rent",
    value: "Mortgage / Rent",
    type: "expenses"
  },
  {
    category: "Living Essentials",
    label: "Telephone",
    value: "Telephone",
    type: "expenses"
  },
  {
    category: "Living Essentials",
    label: "Utilities",
    value: "Utilities",
    type: "expenses"
  },
  {
    category: "Education",
    label: "Education",
    value: "Education",
    type: "expenses"
  },
  {
    category: "Education",
    label: "Student Loans",
    value: "Student Loans",
    type: "expenses"
  },
  {
    category: "Debts Obligations",
    label: "2nd Mortgage / Rent",
    value: "2nd Mortgage / Rent",
    type: "expenses"
  },
  {
    category: "Debts Obligations",
    label: "Child support / Alimony",
    value: "Child support / Alimony",
    type: "expenses"
  },
  {
    category: "Insurance",
    label: "Home Insurance",
    value: "Home Insurance",
    type: "expenses"
  },
  {
    category: "Insurance",
    label: "Life Insurance",
    value: "Life Insurance",
    type: "expenses"
  },
  {
    category: "Insurance",
    label: "Auto Insurance",
    value: "Auto Insurance",
    type: "expenses"
  },
  {
    category: "Personal Expenses",
    label: "Auto Loans",
    value: "Auto Loans",
    type: "expenses"
  },
  {
    category: "Personal Expenses",
    label: "Auto Others",
    value: "Auto Others",
    type: "expenses"
  },
  {
    category: "Personal Expenses",
    label: "Charity / Donations",
    value: "Charity / Donations",
    type: "expenses"
  },
  {
    category: "Personal Expenses",
    label: "Entertainment",
    value: "Entertainment",
    type: "expenses"
  },
  {
    category: "Personal Expenses",
    label: "Gym / Health",
    value: "Gym / Health",
    type: "expenses"
  },
  {
    category: "Personal Expenses",
    label: "Medical Bills",
    value: "Medical Bills",
    type: "expenses"
  },
  {
    category: "Personal Expenses",
    label: "Medical Care",
    value: "Medical Care",
    type: "expenses"
  },
  {
    category: "Personal Expenses",
    label: "Misc / Other",
    value: "Misc / Other",
    type: "expenses"
  },
  {
    category: "Personal Expenses",
    label: "Personal Care",
    value: "Personal Care",
    type: "expenses"
  },
  {
    category: "Personal Expenses",
    label: "Tickets / Fines",
    value: "Tickets / Fines",
    type: "expenses"
  },
]
